const BooleanValue = ({ value }) => {
    return <>{value ? <span className="text-success">&#10003;</span> : <span className="text-danger">&#10005;</span>}</>;
}

export default BooleanValue;